var arrowNavigate, boldExactMatch, handleAutoCompleteSuggestions, handleSearchFieldKeyup, submitSelectedResult;

if (window.Coupons == null) {
  window.Coupons = {};
}

$(function() {
  var searchField, timer;
  Coupons._search_results = false;
  if (!$('html').hasClass('lt-ie10')) {
    searchField = $('#coupons-search-field');
    timer = null;
    $(document).on('mouseover', '.search-results ul li', function(e) {
      $('.search-results ul li').removeClass('highlighted');
    });
    searchField.keyup(function(e) {
      if (e.which === 40) {
        arrowNavigate('down');
        return;
      } else if (e.which === 38) {
        arrowNavigate('up');
        return;
      }
      clearTimeout(timer);
      timer = setTimeout(handleSearchFieldKeyup, 300);
    });
    searchField.focusout(function() {
      return setTimeout(function() {
        if (!((typeof TouchData !== "undefined" && TouchData !== null) || ((typeof Touch !== "undefined" && Touch !== null ? Touch.Data : void 0) != null))) {
          return $("#search-autosuggest").hide();
        }
      }, 500);
    });
    searchField.focus(function() {
      if ($('.search-results ul > li').length > 0) {
        return $("#search-autosuggest").show();
      }
    });
    return searchField.keypress(function(e) {
      var selected;
      if (e.which && e.which === 13) {
        selected = $('.search-results ul li.highlighted');
        if (selected.length > 0) {
          submitSelectedResult();
        } else {
          $("#coupons-search").submit();
        }
        return false;
      }
    });
  }
});

Coupons.searchMade = function(data) {
  return Coupons._search_results;
};

handleAutoCompleteSuggestions = function(data) {
  var _html, _is_touch, searchField, storesBaseUrl;
  Coupons._search_results = true;
  _is_touch = (typeof TouchData !== "undefined" && TouchData !== null) || ((typeof Touch !== "undefined" && Touch !== null ? Touch.Data : void 0) != null);
  searchField = $('#coupons-search-field');
  if (data.stores.length === 0) {
    _html = "<h2 class='no-results remove-for-autocomplete'>" + I18n.t('js.modules.coupons.search.no_results') + "</h2>";
    if ($('h2.no-results').length < 1) {
      $('.search-results').prepend(_html);
    }
    $('.search-stores').hide();
    return false;
  }
  $('.remove-for-autocomplete').remove();
  if (_is_touch) {
    if (data.stores != null) {
      $('.no-search-results').remove();
    }
    $('#freebies-nav-list').hide();
    $(".search-results").show();
    $(".search-results > *").addClass('t-pod');
    $('#coupons-search-field').focus();
  } else {
    data.stores = data.stores.splice(0, 10);
    $("#search-autosuggest").show();
  }
  if (data.stores.length > 0) {
    _html = "";
    storesBaseUrl = searchField.data('stores-base-url');
    $('.search-stores').show();
    _.each(data.stores, function(store) {
      store.name = boldExactMatch(store.name, searchField.val());
      _html += "<li><a href=\"" + storesBaseUrl + "/" + store.slug + "\" data-bhc=\"store:" + store.slug + "\">" + store.name + "<span></span></a></li>";
    });
    $('.search-stores ul').html(_html);
  }
};

handleSearchFieldKeyup = function() {
  var couponsBaseUrl, searchField;
  searchField = $('#coupons-search-field');
  if (searchField.val() === "") {
    $('#search-autosuggest').hide();
    $('#freebies-nav-list').show();
    return false;
  }
  couponsBaseUrl = searchField.data('coupons-base-url');
  return $.ajax({
    data: {
      searchterm: searchField.val()
    },
    dataType: 'json',
    success: handleAutoCompleteSuggestions,
    url: couponsBaseUrl + "/autocomplete"
  });
};

arrowNavigate = function(direction) {
  var current, results, storeResults;
  storeResults = $('.search-stores ul li');
  results = $('.search-results ul li');
  current = $('.search-results ul li.highlighted');
  if (current.length === 0) {
    return results.first().addClass('highlighted');
  } else {
    current.removeClass('highlighted');
    if (direction === 'up') {
      if (current.is('.search-stores ul li:first') === true) {
        return storeResults.last().addClass('highlighted');
      } else {
        return current.prev().addClass('highlighted');
      }
    } else if (direction === 'down') {
      if (current.is('.search-stores ul li:last') === true) {
        return storeResults.first().addClass('highlighted');
      } else {
        return current.next().addClass('highlighted');
      }
    }
  }
};

submitSelectedResult = function() {
  var selected, url;
  selected = $('.search-results ul li.highlighted');
  if (selected.length > 0) {
    url = selected.find('a').attr('href');
    window.location = url;
  }
};

boldExactMatch = function(result, value) {
  var regex;
  regex = new RegExp(value, 'i');
  return result = result.replace(regex, "<span>" + value + "</span>");
};

